<script setup lang="ts">
import { computed, ref } from "vue";

const props = defineProps({
    label: {
        type: String,
        default: "",
        required: true,
    },
    value: {
        type: Number,
        required: true,
    },
    name: {
        type: String,
        default: "",
        required: true,
    },
    prefix: {
        type: String,
        default: "",
    },
    hasSuffix: {
        type: Boolean,
        required: true,
    },
    suffix: {
        type: String,
        default: "",
    },
    postSuffix: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["update:value"]);
const model = computed({
    get() {
        return props.value;
    },
    set(value) {
        emit("update:value", value);
    },
});
const inputIsFocus = ref(false);

const rangeMaxCharacterLengthInPx = (additionalWidth: number) => {
    const singleLetterWidth = 9;
    if (props.hasSuffix && props.postSuffix) {
        return (
            props.value.toString().length * singleLetterWidth + additionalWidth
        );
    } else {
        return props.value.toString().length * singleLetterWidth;
    }
};

const isNumber = (evt: KeyboardEvent) => {
    const regex = /\d|Enter/g;
    if (!regex.test(evt.key)) return evt.preventDefault();
};
</script>
<template>
    <div
        class="[ c-floating-label-input ]"
        :class="{ 'is-focus': inputIsFocus }"
    >
        <div class="[ c-floating-label-input__prefix ]">
            <span v-if="prefix" v-html="prefix"></span>
            <div
                v-if="hasSuffix"
                class="[ c-floating-label-input__suffix ]"
                :style="
                    'transform:translateX(' +
                    rangeMaxCharacterLengthInPx(0) +
                    'px)'
                "
            >
                {{ suffix }}
            </div>
            <span
                v-if="postSuffix"
                class="[ c-floating-label-input__post-suffix ]"
                :style="
                    'transform:translateX(' +
                    rangeMaxCharacterLengthInPx(8) +
                    'px)'
                "
            >
                {{ postSuffix }}
            </span>
        </div>
        <label class="[ c-floating-label-input__label ]" :for="name">
            {{ label }}
        </label>
        <input
            :id="name"
            v-model.lazy="model"
            type="number"
            :placeholder="label"
            class="[ c-floating-label-input__input ]"
            @keypress="isNumber($event)"
            @focusin="inputIsFocus = true"
            @focusout="inputIsFocus = false"
        />
    </div>
</template>
